import logo from './logo.svg';
import './App.css';
import Weather from './components/Weather.js'

function App() {
  return (
    <div className="App">
      <header className="App-header">
      </header>
      <Weather />
    </div>
  );
}

export default App;
